import { createForm } from "@formily/core";
import { createSchemaField } from "@formily/react";
import {
  Form,
  FormItem,
  FormLayout,
  Input,
  Select,
  Cascader,
  DatePicker,
  Submit,
  FormGrid,
  ArrayItems,
  Editable,
  FormButtonGroup,
  NumberPicker,
} from "@formily/antd-v5";
import { Rate, Button } from "antd";
import { useTranslation } from "react-i18next";
import { NCALayerClient } from "ncalayer-js-client";

const form = createForm();
const SchemaField = createSchemaField({
  components: {
    FormItem,
    FormGrid,
    FormLayout,
    Input,
    DatePicker,
    Cascader,
    Select,
    ArrayItems,
    Editable,
    Rate,
    NumberPicker,
  },
});

const schema = JSON.parse(`{
    "form": {
        "labelCol": 6,
        "wrapperCol": 12
      },
      "schema": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "title": "Name",
            "x-decorator": "FormItem",
            "x-component": "Input",
            "x-validator": [],
            "x-component-props": {},
            "x-decorator-props": {},
            "required": true,
            "x-designable-id": "6xpud2789cv",
            "x-index": 0,
            "name": "name"
          },
          "location": {
            "title": "Location",
            "x-decorator": "FormItem",
            "x-component": "Select",
            "x-validator": [],
            "x-component-props": {
              "showSearch": false,
              "placeholder": " "
            },
            "x-decorator-props": {
              "tooltip": "Here location dropdown"
            },
            "name": "location",
            "enum": [
              {
                "children": [],
                "label": "Atyrau",
                "value": "at"
              },
              {
                "children": [],
                "label": "Eskene West",
                "value": "ew"
              }
            ],
            "x-designable-id": "3y1h2sp3hgz",
            "x-index": 1
          },
          "comment": {
            "type": "string",
            "title": "Comment",
            "x-decorator": "FormItem",
            "x-component": "Input.TextArea",
            "x-validator": [],
            "x-component-props": {},
            "x-decorator-props": {},
            "required": true,
            "x-designable-id": "b1ei9rxxkpl",
            "x-index": 2,
            "name": "comment"
          }
        },
        "x-designable-id": "1rzkznybjez"
      }
    }`);

const FormViewPage = () => {
  const { t } = useTranslation();
  const handleSign = async () => {
    const ncalayerClient = new NCALayerClient();

    try {
      await ncalayerClient.connect();
    } catch (error: any) {
      alert(`${t("Failed to connect to NCALayer:")} ${error.toString()}`);
      return;
    }

    let base64EncodedSignature;

    const fileData = "";

    try {
      base64EncodedSignature = await ncalayerClient.basicsSignCMS(
        NCALayerClient.basicsStoragesAll,
        fileData,
        NCALayerClient.basicsCMSParamsAttached,
        NCALayerClient.basicsSignerSignAny
      );
    } catch (error: any) {
      if (error.canceledByUser) {
        alert(t("Action cancelled by user."));
      }

      alert(error.toString());
      return;
    }

    return base64EncodedSignature;
  };

  return (
    <Form form={form} labelCol={5} wrapperCol={16} onAutoSubmit={console.log}>
      <Button onClick={handleSign}>{t("Sign with EDS")}</Button>

      <SchemaField schema={schema.schema} />
      <FormButtonGroup.FormItem>
        <Submit block size="large">
          {t("Submit")}
        </Submit>
      </FormButtonGroup.FormItem>
    </Form>
  );
};

export default FormViewPage;
